import React from 'react';

class Optgroup extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            expanded: false
        }
        
        this.toggleExpand = this.toggleExpand.bind(this);
    }
    
    toggleExpand() {
        this.setState({
            expanded: !this.state.expanded
        });        
    }
    
    getCheckedClass(){
        switch(this.props.selected){
            case 'yes':
                return 'fas fa-check-square checked';
            case 'no':
                return 'far fa-square';
            default:
                return 'far fa-check-square';
        }
    }

    
    render (){
        const { label, children, selected, customID } = this.props; 
        const idProp = customID ? {id: customID} : {};
        return  <div className="optgroup" data-group-name={String(label).toLowerCase()} {...idProp}>
            <div className="option-item">
                <span onClick={this.props.selectAll} className={this.getCheckedClass()}></span>
                <span onClick={this.toggleExpand} className="optgroup-label">{label}</span>
                <span onClick={this.toggleExpand} className={`fa fa-caret-${this.state.expanded?'up':'down'}`}></span>
            </div>
            {this.state.expanded && <div className="options-second-level">

                {children}
            </div>}
        </div>;
    }
}


export default Optgroup;